
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOnHorizontal as ObiMotorOnHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-on-horizontal.js';
 
 
 

 
 export const ObiMotorOnHorizontal = createComponent({
   react: React,
   tagName: 'obi-motor-on-horizontal',
   elementClass: ObiMotorOnHorizontalElement,
   events: {
     
   }
  });
 
 